"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import { getProfileViewerContext } from "@/helpers/ProfileHelpers";
import { clearIdentity, disableAnalytics, identify, initAnalytics, trackPageView } from "@/services/analytics/mixpanel";
import { classifyPageView } from "@/services/analytics/pageClassification";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
const getProfileRouteTarget = (pathname: string): string | null => {
  return pathname.split("/").find(segment => segment.length > 0) ?? null;
};
export default function MixpanelSetup() {
  const $ = _c(28);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    connectedProfile,
    fetchingProfile
  } = useAuth();
  const {
    performanceConsent
  } = useCookieConsent();
  const lastTrackedPageKeyRef = useRef(null);
  const identifiedProfileIdRef = useRef(null);
  const hasConsent = performanceConsent === true;
  let pageView;
  let t0;
  if ($[0] !== connectedProfile || $[1] !== pathname || $[2] !== searchParams) {
    pageView = classifyPageView({
      pathname,
      searchParams
    });
    t0 = pageView.logicalPage.startsWith("profile_") ? getProfileViewerContext({
      connectedProfile,
      handleOrWallet: getProfileRouteTarget(pathname)
    }) : null;
    $[0] = connectedProfile;
    $[1] = pathname;
    $[2] = searchParams;
    $[3] = pageView;
    $[4] = t0;
  } else {
    pageView = $[3];
    t0 = $[4];
  }
  const profileViewerContext = t0;
  let t1;
  let t2;
  if ($[5] !== hasConsent) {
    t1 = () => {
      if (!hasConsent) {
        disableAnalytics();
        lastTrackedPageKeyRef.current = null;
        identifiedProfileIdRef.current = null;
        return;
      }
      initAnalytics();
    };
    t2 = [hasConsent];
    $[5] = hasConsent;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] !== connectedProfile || $[9] !== hasConsent) {
    t3 = () => {
      if (!hasConsent) {
        return;
      }
      const profileId = connectedProfile?.id !== undefined && connectedProfile.id !== null ? String(connectedProfile.id) : null;
      if (!profileId) {
        if (identifiedProfileIdRef.current !== null) {
          clearIdentity();
          identifiedProfileIdRef.current = null;
        }
        return;
      }
      if (identifiedProfileIdRef.current === profileId) {
        return;
      }
      identify(profileId);
      identifiedProfileIdRef.current = profileId;
    };
    $[8] = connectedProfile;
    $[9] = hasConsent;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = connectedProfile?.id;
  let t5;
  if ($[11] !== hasConsent || $[12] !== t4) {
    t5 = [t4, hasConsent];
    $[11] = hasConsent;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t3, t5);
  let t6;
  if ($[14] !== connectedProfile || $[15] !== fetchingProfile || $[16] !== hasConsent || $[17] !== pageView || $[18] !== pathname || $[19] !== profileViewerContext) {
    t6 = () => {
      if (!hasConsent) {
        return;
      }
      if (pageView.logicalPage.startsWith("profile_") && fetchingProfile) {
        return;
      }
      if (lastTrackedPageKeyRef.current === pageView.trackingKey) {
        return;
      }
      lastTrackedPageKeyRef.current = pageView.trackingKey;
      trackPageView(pathname, {
        has_connected_profile: connectedProfile?.id !== undefined && connectedProfile.id !== null,
        logical_page: pageView.logicalPage,
        page_group: pageView.pageGroup,
        profile_viewer_context: profileViewerContext ?? undefined,
        route_pattern: pageView.routePattern
      });
    };
    $[14] = connectedProfile;
    $[15] = fetchingProfile;
    $[16] = hasConsent;
    $[17] = pageView;
    $[18] = pathname;
    $[19] = profileViewerContext;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const t7 = connectedProfile?.id;
  let t8;
  if ($[21] !== fetchingProfile || $[22] !== hasConsent || $[23] !== pageView || $[24] !== pathname || $[25] !== profileViewerContext || $[26] !== t7) {
    t8 = [t7, fetchingProfile, hasConsent, pageView, pathname, profileViewerContext];
    $[21] = fetchingProfile;
    $[22] = hasConsent;
    $[23] = pageView;
    $[24] = pathname;
    $[25] = profileViewerContext;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  useEffect(t6, t8);
  return null;
}